#import "@/components/common/CraftAssetFragment.gql"

fragment VideoWithDescriptionFragment on videoWithDescription_Entry {
  typeHandle
  heading
  description
  preview {
    ...CraftAssetFragment
  }
  video {
    ...CraftAssetFragment
  }
  textOverlay
  autoplay
  position
  backgroundGray
  centered
}
